export const sizeLabelMap: { [key: string]: string } = {
    xs: "Extra Small",
  s: "Small",
  m: "Medium",
  l: "Large",
  xl: "Extra Large",
  "2xl": "2 Extra Large",
  "3xl": "3 Extra Large",
  small: "Small",
  medium: "Medium",
  large: "Large",
  "extra small": "Extra Small",
  "extra large": "Extra Large",
  "2 extra large": "2 Extra Large",
  "3 extra large": "3 Extra Large",
  onesize: "One Size",
  "one size": "One Size",
};
